import { slab, wallX, wallZ, goal, sign, neon, checkpoint, edgeLights } from '../kit.js';

/**
 * Teaches the whole verb set in one move: two lit panels facing each other
 * across a gap that cannot be jumped. Nothing else in the level is portalable,
 * so there is exactly one thing to try.
 */
export default {
  id: 'boot',
  name: 'BOOT SEQUENCE',
  blurb: 'Two panels. One gap. Learn the gun.',
  mode: { type: 'sprint', par: 10 },
  redline: { seconds: 5 },   // docs/REDLINE.md; seeded from the board, honesty pass pending
  spawn: { p: [0, 0.4, 6], yaw: 0 },
  killY: -90,
  env: {
    fog: 0x140b26,
    fogDensity: 0.0055,
    sky: { zenith: 0x05040f, horizon: 0x160c2c, glow: 0x5a1a6e, aurora: 0x0e6f8a },
    floorY: -300,
  },
  objects: [
    // ---- launch bay
    slab(0, 0, 0, 18, 18, 'plate', 1.4),
    ...edgeLights(0, 0, 0, 18, 18, 'cyan'),
    wallZ(0, 0, 9.7, 22, 9, 'panel', 1.4),          // portalable, behind the player
    wallX(-9.7, 0, 0, 18, 9, 'panel', 1.4),         // portalable, to the left
    wallX(9.7, 0, 0, 18, 9, 'plate', 1.4),
    neon(0, 8.4, 9.0, [18, 0.14, 0.14], 'cyan'),
    neon(-9.0, 8.4, 0, [0.14, 0.14, 18], 'cyan'),

    // ---- receiving bay, across the gap
    slab(0, 0, -42, 18, 18, 'plate', 1.4),
    ...edgeLights(0, 0, -42, 18, 18, 'magenta'),
    wallZ(0, 0, -51.7, 22, 11, 'panel', 1.4),       // portalable, faces the player
    wallX(-9.7, 0, -42, 18, 9, 'plate', 1.4),
    wallX(9.7, 0, -42, 18, 9, 'plate', 1.4),
    neon(0, 10.4, -51.0, [18, 0.14, 0.14], 'magenta'),

    goal(0, 0, -45.5, 0),
    checkpoint(0, 0, -36),

    // ---- guidance
    sign(0, 3.6, -4.5, 0, [
      'BOOT SEQUENCE',
      'LIT PANELS TAKE PORTALS',
      'FIRE A, FIRE B, WALK IN',
    ]),
    sign(-8.6, 4.6, -3, 90, ['PANEL', 'PORTAL READY'], '#2ff3ff'),
    sign(0, 7.5, -50.4, 0, ['LANDING PANEL'], '#ff2fd0'),
    sign(6.6, 3.0, -6, 0, ['GAP: 24 METRES', 'YOU CANNOT JUMP IT'], '#ffb020'),
  ],
};
